export default __webpack_public_path__ + "static/media/person.4bc164f0.png";